import script from "./ai-ocr-documents-uploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ai-ocr-documents-uploader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__